export default __webpack_public_path__ + "static/media/img-soon-bg-grid.507433b0.svg";